import { useSelector } from "react-redux";
import { Session } from "src/pages/Sessions";
import useSWR from "swr";
import { Card, CardHeader } from "./ui/card";
import SessionCard from "./SessionCard";

const fetcher = (token) => async (url) => {
  const res = await fetch(url, { headers: { Authorization: token } });

  if (!res.ok) {
    throw await res.json();
  }

  return res.json();
};

export function SessionFromId({ sessionId }: { sessionId: string }) {
  const user = useSelector((state: any) => state.user);

  const { data, error, isLoading } = useSWR<Session>(
    `${process.env.REACT_APP_API_URL}/sessions/${encodeURIComponent(
      sessionId
    )}`,
    fetcher(user.token)
  );

  return (
    <>
      {isLoading && !data && (
        <Card>
          <CardHeader>Načítání</CardHeader>
        </Card>
      )}
      {error && !isLoading && !data && (
        <Card>
          <CardHeader>Vyskytla se chyba</CardHeader>
        </Card>
      )}
      {data && <SessionCard session={data} />}
    </>
  );
}

export default function SessionIdList({
  sessionIds,
}: {
  sessionIds: string[];
}) {
  return (
    <div className="flex flex-col gap-4">
      {sessionIds.map((sessionId) => (
        <SessionFromId sessionId={sessionId} key={sessionId} />
      ))}
    </div>
  );
}
